<template>
  <div class="b_box">
    <div class="container">
      <div class="top_title">
               <div class="box_nav">
            <span
              class="box_item"
              v-for="(item,index) in dataList"
              :class="{'select_active1':item.select}"
              :key="index"
              @click="selectALL(index,item)"
            >{{item.key}}</span>
          </div>
               <div class="t_data">
                     <div class="s_data" v-if="selectKey=='today'">
                          <div class="s_left" @click="preDate">
                               <img src="../../../../assets/image/arrow_left.png"/>
                               <span>上一天</span>
                          </div>
                          <span class="center" :class="{'center_active':clickNum==0}">{{aboutDay}}</span>
                          <div class="s_left s_right" :class="{'nextactive':true}" @click="nextDate">
                               <span :class="{'s_active':clickNum==0}">下一天</span>
                               <img src="../../../../assets/image/arrow_right.png"/>
                          </div>
                     </div>
                     <div class="s_data" v-if="selectKey=='week'">
                          <div class="s_left" @click="preWeek">
                               <img src="../../../../assets/image/arrow_left.png"/>
                               <span>上周</span>
                          </div>
                          <span class="center" :class="{'center_active':clickNum==0}">{{startWeekTime}} 至 {{endWeekTime}}</span>
                          <div class="s_left s_right" @click="nextWeek">
                               <span :class="{'s_active':clickNum==0}">下周</span>
                               <img src="../../../../assets/image/arrow_right.png"/>
                          </div>
                     </div>
                     <div class="s_data " v-if="selectKey=='mouth'">
                          <div class="s_left" @click="preMouth">
                               <img src="../../../../assets/image/arrow_left.png"/>
                               <span>上月</span>
                          </div>
                          <span class="center" :class="{'center_active':clickNum==0}">{{currentMouth.substring(0,4)}}年{{currentMouth.substring(5,7)}}月份</span>
                          <div class="s_left s_right" @click="nextMouth">
                               <span :class="{'s_active':clickNum==0}">下月</span>
                               <img src="../../../../assets/image/arrow_right.png"/>
                          </div>
                     </div>
                     <div class="s_data two_data" v-if="selectKey=='all'">
                          <!-- <div></div>
                          <span class="center">{{startAllTime}} V 至 {{endAllTime}} V </span>
                          <div></div> -->
                          <div class="all_left" @click="AllstartTime">
                              <span :class="{'all_active':isopacity}">{{startAllTime}}</span>
                              <img src="../../../../assets/image/icon_la.png"/>
                          </div>
                          <span class="all_center" :class="{'all_active':isopacity}">至</span>
                          <div class="all_left" @click="AllendTime">
                              <span :class="{'all_active':isopacity}">{{endAllTime}}</span>
                              <img src="../../../../assets/image/icon_la.png"/>
                          </div>
                     </div>
                     <div class="pro_item">
                        <div class="item_left">
                            <div class="left">
                                <div class="num">
                                    <span>{{total}}</span>
                                    <span>起</span>
                                </div>
                                <p class="status">{{cityName}}</p>
                            </div>
                            <div class="center"></div>
                            <div class="left">
                                <div class="num">
                                    <span>{{totalPrice|filt}}</span>
                                    <span v-if="parseInt(totalPrice)<10000">元</span>
                                    <span v-if="parseInt(totalPrice)>=10000&&parseInt(totalPrice)<100000000">万元</span>
                                    <span v-if="parseInt(totalPrice)>=100000000">亿</span>
                                </div>
                                <p class="status">退货总金额</p>
                            </div>
                         </div>
                         <div class="line"></div>
                     </div>
                     <div class="status_num">
                           <div class="status_item" v-if="baseList">
                                 <div class="item_num" @click="changeStatus('processing')">
                                      <p class="pro_status" :class="{'pro_actve':refundType=='processing'}">处理中</p>
                                      <div class="pro_num">
                                           <span :class="{'pro_actve':refundType=='processing'}">{{baseList.waitHandle}}</span>
                                           <span :class="{'pro_actve':refundType=='processing'}">起</span>
                                      </div>
                                 </div>
                                 <div class="line"></div>
                                 <div class="item_num" @click="changeStatus('refundSuccess')">
                                      <p class="pro_status" :class="{'pro_actve':refundType=='refundSuccess'}">退货成功</p>
                                      <div class="pro_num">
                                           <span :class="{'pro_actve':refundType=='refundSuccess'}">{{baseList.refundSuccess}}</span>
                                           <span :class="{'pro_actve':refundType=='refundSuccess'}">起</span>
                                      </div>
                                 </div>
                                 <div class="line"></div>
                                 <div class="item_num" @click="changeStatus('waitAccept')">
                                      <p class="pro_status" :class="{'pro_actve':refundType=='waitAccept'}">待受理</p>
                                      <div class="pro_num">
                                           <span :class="{'pro_actve':refundType=='waitAccept'}">{{baseList.waitAccept}}</span>
                                           <span :class="{'pro_actve':refundType=='waitAccept'}">起</span>
                                      </div>
                                 </div>
                                 <div class="line"></div>
                                 <div class="item_num" @click="changeStatus('userRevoke')">
                                      <p class="pro_status" :class="{'pro_actve':refundType=='userRevoke'}">用户撤销</p>
                                      <div class="pro_num">
                                           <span :class="{'pro_actve':refundType=='userRevoke'}">{{baseList.userRevoke}}</span>
                                           <span :class="{'pro_actve':refundType=='userRevoke'}">起</span>
                                      </div>
                                 </div>
                                 <div class="line"></div>
                                 <div class="item_num" @click="changeStatus('refuseAccept')">
                                      <p class="pro_status" :class="{'pro_actve':refundType=='refuseAccept'}">不予受理</p>
                                      <div class="pro_num">
                                           <span :class="{'pro_actve':refundType=='refuseAccept'}">{{baseList.refuseAccept}}</span>
                                           <span :class="{'pro_actve':refundType=='refuseAccept'}">起</span>
                                      </div>
                                 </div>
                           </div>
                     </div>

               </div>
         </div>

      <div class="all_list">
        <div class="all_list_top">
          <div class="all_list_item" v-if="currentTotalPrice!=0">
            <span>申请总金额</span>
            <span>
              {{currentTotalPrice|filt}}
              <i v-if="parseInt(currentTotalPrice)<10000">(元)</i>
              <i
                v-if="parseInt(currentTotalPrice)>=10000&&parseInt(currentTotalPrice)<100000000"
              >(万元)</i>
              <i v-if="parseInt(currentTotalPrice)>=100000000">(亿元)</i>
            </span>
          </div>
          <div class="all_list_item all_list_active" v-if="showchangeStatus">
            <span>退款总金额</span>
            <span>
              {{totalCityPrice|filt}}
              <i v-if="parseInt(totalCityPrice)<10000">(元)</i>
              <i v-if="parseInt(totalCityPrice)>=10000&&parseInt(totalCityPrice)<100000000">(万元)</i>
              <i v-if="parseInt(totalCityPrice)>=100000000">(亿元)</i>
            </span>
          </div>
          <div
            class="all_item"
            v-for="(item,index) in proList"
            :key="index"
            @click="goLeaderDetail(item)"
          >
            <span class="tip_one">{{item.areaName}}</span>
            <span class="tip_two">{{item.num}} 起</span>
            <div class="right">
              <span class="price">￥{{item.amount}}</span>
              <img src="../../../../assets/image/icon_right.png" class="arrow_right" />
            </div>
          </div>
          <div class="box1" v-if="isNolist">
            <img src="../../../../assets/empty/ic_wuxingxi.png" />
            <p class="tip1">暂无数据</p>
          </div>
        </div>
      </div>
      <!-- 回到首页的logo -->
      <div class="go_home" @click="goHome">
        <img src="../../../../assets/image/go_home.png" />
      </div>
    </div>
      <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
  </div>
</template>
<script>
    import moment from 'moment';
    import timePick from '../../../../components/base/timePick'
    import api from '../../../../service/modules/refund';
    import util from '../../../../utils/common';
    export default {
        components: {
            timePick
        },
        data () {
            return {
                isNolist: false,
                dataList: [
                    { key: '日', select: true, value: 'today' },
                    { key: '周', select: false, value: 'week' },
                    { key: '月', select: false, value: 'mouth' },
                    { key: '全部', select: false, value: 'all' }
                ],
                baseList: '',
                currentTime: new Date().getTime(),
                currentMouth: moment(new Date().getTime()).format('YYYY-MM'),
                // selectKey: this.$router.currentRoute.query.aboutTime,
                selectKey: 'today',
                cityCode: this.$router.currentRoute.query.citycode,
                refundType: this.$router.currentRoute.query.refundType,
                aboutDay: moment(new Date().getTime()).format('YYYY-MM-DD'),
                startWeekTime: '',
                endWeekTime: '',
                startAllTime: '2019-05-01',
                endAllTime: moment(new Date().getTime()).format('YYYY-MM-DD'),
                changeTime: '',
                startTime: this.$store.state.refund.startTime,
                endTime: this.$store.state.refund.endTime,
                proList: [],
                total: '0',
                totalPrice: '0',
                cityName: this.$router.currentRoute.query.cityName,
                clickNum: 0,
                isopacity: true,
                totalCityPrice: 0,
                currentTotalPrice: 0,
                showchangeStatus: false
            };
        },
        computed: {},
        mounted () {
            window.addEventListener('scroll', this.handleScroll);
        },
        created () {
            this._initDate();
            this.getReturnSort();
            this.getInfoList();
        },
        methods: {
            _initDate () {
                // 初始化一些数据
                if (this.selectKey === 'week') {
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startWeekTime = data.start;
                    this.endWeekTime = data.end;
                    this.startTime = data.start;
                    this.endTime = data.end;
                }
                this.dataList.map((item, index) => {
                    if (item.value === this.selectKey) {
                        this.$set(item, 'select', true);
                    } else {
                        this.$set(item, 'select', false);
                    }
                });
            },
            goHome () {
                this.$router.push('leader');
            },
            goLeaderDetail (item, value) {
                // 详情页面
                this.$router.push(
                    'leaderDetail?cityCode=' +
                        item.areaCode +
                        '&startTime=' +
                        this.startTime +
                        '&endTime=' +
                        this.endTime +
                        '&refundType=' +
                        this.refundType +
                        '&total=' +
                        item.num +
                        '&totalprice=' +
                        item.amount
                );
            },
            showNext () {
                if (this.aboutDay === moment(new Date().getTime()).format('YYYY-MM-DD')) {
                    return true;
                } else {
                    return false;
                }
            },
            getInfoList () {
                api
                    .workbenchLeader({
                        areaId: this.cityCode,
                        startDate: this.startTime,
                        endDate: this.endTime
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.baseList = res.data;
                            this.total = res.data.allReturnList;
                            this.totalPrice = res.data.totalPrice;
                        }
                    });
            },
            AllstartTime () {
                this.changeTime = 'startTime';
                this.$refs.timePick.showPicker();
            },
            AllendTime () {
                this.changeTime = 'endTime';
                this.$refs.timePick.showPicker();
            },
            getTimeValue (value) {
                if (this.changeTime === 'startTime') {
                    if (new Date(value).getTime() < new Date('2019-05-01').getTime()) {
                        // 选择时间小于最小的时间
                        this.$Toast({
                            message: '起始时间不能小于2019-05-01'
                        });
                        return;
                    } else if (
                        new Date(value).getTime() > new Date(this.endTime).getTime()
                    ) {
                        this.$Toast({
                            message: '起始时间不能大于开始时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.startAllTime = value;
                    this.startTime = value;
                } else {
                    if (new Date(value).getTime() < new Date(this.startAllTime).getTime()) {
                        this.$Toast({
                            message: '结束时间不能小于开始时间'
                        });
                        return;
                    }
                    this.isopacity = false;
                    this.endAllTime = value;
                    this.endTime = value;
                }
                this.getReturnSort();
                this.getInfoList();
            },
            selectALL (index, item) {
                // 选择日，周，月
                this.clickNum = 0;
                this.dataList.map((item, index) => {
                    this.$set(this.dataList[index], 'select', false);
                });
                this.$set(this.dataList[index], 'select', true);
                this.selectKey = item.value;
                if (item.value === 'today') {
                    // 选择日
                    this.aboutDay = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.startTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                } else if (item.value === 'week') {
                    // 选择周
                    let nowTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    var data = util.getWeekStartEnd(moment, nowTime);
                    this.startWeekTime = data.start;
                    this.endWeekTime = data.end;
                    this.startTime = data.start;
                    this.endTime = data.end;
                } else if (item.value === 'mouth') {
                    // 选择月
                    this.currentMouth = moment(new Date().getTime()).format('YYYY-MM');
                    let currentDateMon = new Date();
                    // 获取当前月的第一天
                    this.startTime = this.getCurrentMonthFirst(currentDateMon);
                    // 获取当前月的最后一天
                    this.endTime = this.getCurrentMonthLast(currentDateMon);
                } else if (item.value === 'all') {
                    //
                    this.startAllTime = '2019-05-01';
                    this.endAllTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                    this.startTime = '2019-05-01';
                    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
                }
                this.getReturnSort();
                this.getInfoList();
            },
            getCurrentMonthFirst (d) {
                // 每个月第一天
                var date = new Date(d);
                date.setDate(1);
                var month = parseInt(date.getMonth() + 1);
                var day = date.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            getCurrentMonthLast (d) {
                // 每个月最后一天
                var date = new Date(d);
                var currentMonth = date.getMonth();
                var nextMonth = ++currentMonth;
                var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                var oneDay = 1000 * 60 * 60 * 24;
                var lastTime = new Date(nextMonthFirstDay - oneDay);
                var month = parseInt(lastTime.getMonth() + 1);
                var day = lastTime.getDate();
                if (month < 10) {
                    month = '0' + month;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                return date.getFullYear() + '-' + month + '-' + day;
            },
            preDate () {
                // 上一天
                this.clickNum++;
                this.aboutDay = moment(this.currentTime - 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                this.currentTime = new Date(this.aboutDay).getTime();
                this.startTime = this.aboutDay;
                this.endTime = this.aboutDay;
                this.getInfoList();
                this.getReturnSort();
            },
            nextDate () {
                // 下一天
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                this.aboutDay = moment(this.currentTime + 24 * 60 * 60 * 1000).format(
                    'YYYY-MM-DD'
                );
                this.currentTime = new Date(this.aboutDay).getTime();
                this.startTime = this.aboutDay;
                this.endTime = this.aboutDay;
                this.getInfoList();
                this.getReturnSort();
            },
            preMouth () {
                // 上一个月
                this.clickNum++;
                let selectMouth = ''
                if (new Date(this.currentMouth).getMonth() > 0) {
                    var mouth = parseInt(new Date(this.currentMouth).getMonth());
                    if (mouth < 10) {
                        mouth = '0' + mouth;
                    }
                    let selectMouth =
                        new Date(this.currentMouth).getFullYear() + '-' + mouth + '';
                    this.currentMouth = selectMouth;
                } else {
                    let selectMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) - 1 + '-' + '12';
                    this.currentMouth = selectMouth;
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01';
                this.endTime = this.currentMouth + '-' + time.getDate();
                this.getInfoList();
                this.getReturnSort();
            },
            nextMouth () {
                // 下一个月
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                var mouth = parseInt(new Date(this.currentMouth).getMonth()) + 2;
                if (mouth < 10) {
                    mouth = '0' + mouth;
                }
                let selectMouth = ''
                if (mouth > 12) {
                    selectMouth =
                        parseInt(new Date(this.currentMouth).getFullYear()) + 1 + '-' + '01';
                    this.currentMouth = selectMouth;
                } else {
                    selectMouth =
                        new Date(this.currentMouth).getFullYear() + '-' + mouth;
                    this.currentMouth = selectMouth;
                }
                var time = new Date(
                    this.currentMouth.substring(0, 4),
                    this.currentMouth.substring(5, 7),
                    0
                );
                this.startTime = this.currentMouth + '-01';
                this.endTime = this.currentMouth + '-' + time.getDate();
                this.getInfoList();
                this.getReturnSort();
            },
            preWeek () {
                // 上一周
                this.clickNum++;
                this.endWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startWeekTime = moment(
                    new Date(this.startWeekTime).getTime() - 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime;
                this.endTime = this.endWeekTime;
                this.getInfoList();
                this.getReturnSort();
            },
            nextWeek () {
                // 下一周
                if (this.clickNum === 0) {
                    return;
                } else {
                    this.clickNum--;
                }
                this.startWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 24 * 36e5
                ).format('YYYY-MM-DD');
                this.endWeekTime = moment(
                    new Date(this.endWeekTime).getTime() + 7 * 24 * 36e5
                ).format('YYYY-MM-DD');
                this.startTime = this.startWeekTime;
                this.endTime = this.endWeekTime;
                this.getInfoList();
                this.getReturnSort();
            },
            changeStatus (value) {
                // 选择退货状态
                console.log(value);
                if (value === 'refundSuccess') {
                    this.showchangeStatus = true;
                } else {
                    this.showchangeStatus = false;
                }
                this.refundType = value;
                this.getReturnSort();
            },
            getReturnSort () {
                api
                    .returnSort({
                        areaId: this.cityCode,
                        startDate: this.startTime,
                        endDate: this.endTime,
                        refundType: this.refundType
                    })
                    .then(res => {
                        if (res.ret === 0) {
                            this.proList = res.data;
                            if (res.data.length === 0) {
                                this.isNolist = true;
                                this.currentTotalPrice = 0;
                                this.totalCityPrice = 0;
                            } else {
                                this.isNolist = false;
                                let price = 0;
                                let totalPrice = 0;
                                for (var i = 0; i < res.data.length; i++) {
                                    price += res.data[i].returnAmount;
                                    totalPrice += res.data[i].amount;
                                }
                                this.totalCityPrice = price;
                                this.currentTotalPrice = totalPrice;
                            }
                        }
                    });
            }
        },
        filters: {
            filt (value) {
                if (parseInt(value) < 10000) {
                    return value;
                } else if (parseInt(value) >= 10000 && parseInt(value) < 100000000) {
                    return (parseInt(value) / 10000).toFixed(2);
                } else if (parseInt(value) >= 100000000) {
                    return (parseInt(value) / 100000000).toFixed(2);
                }
            }
        }
    };
</script>
<style scoped lang="less">
.b_box {
  background-color: #fafafa;
}
.container {
  //   width: 100%;
  .top_title{
       width:100%;
       position: fixed;
       left:0;
       top:0;
       z-index: 2;
         background-color: #36B374;
       .s_time{
           height:30px;
          padding: 20px 16px 0 16px;
           display: flex;
           display: -webkit-flex;
           align-items: center;
           flex-direction: row;
           justify-content: space-around;
           font-size:16px;
           color:#666;
           background-color: #36B374;
           border: 1px solid #ffffff;
           border-radius: 2px;
           .item{
               display: block;
               float: left;
               width: 25%;
               height: 100%;
               line-height: 30px;
               text-align: center;
               color:#ccc;
               border-right: 1px solid #ffffff;
           }
            .item:last-child{
                    border: none;
            }
           .select_active{
               color:#36B374;
               background-color: #fff;
           }

       }
       .t_data{
           width:100%;
           height:200px;
           background: #36B374;
           padding:20px 16px 0 16px;
           box-sizing: border-box;
           position: relative;
           .jiao{
                position: absolute;
                left:29px;
                top:-21px;
                width:14px;
                height:14px;
                border-top:14px solid transparent;
                border-right:14px solid transparent;
                border-bottom:14px solid #36B374;
                border-left:14px solid transparent;
            }
            .jiao1_active{
                left:29px;
            }
            .jiao2_active{
                left:120px;
            }
            .jiao3_active{
                left:210px;
            }
            .jiao4_active{
                left:307px;
            }
           .s_data{
               width:100%;
               display: flex;
               display: -webkit-flex;
               align-items: center;
               flex-direction: row;
               justify-content: space-between;
               .s_left{
                  display: flex;
                  display: -webkit-flex;
                  align-items: center;
                  flex-direction: row;
                  img{
                      width:7px;
                      height:11px;
                  }
                  span{
                      font-size:14px;
                      color:#fff;
                      margin-left:6px;
                  }
                  .s_active{
                      opacity: 0.3!important;
                  }
               }
               .all_center{
                   font-size:14px;
                   color:#fff;
                   opacity: 0.4;
               }
               .all_left{
                  display: flex;
                  display: -webkit-flex;
                  align-items: center;
                  flex-direction: row;
                  span{
                      font-size:14px;
                      color:#fff;
                  }
                  img{
                      width:11px;
                      height:7px;
                      margin-left:6px;
                  }
                  .s_active{
                      opacity: 0.3!important;
                  }
               }
               .all_active{
                   opacity: 0.5;
               }
               .s_right{
                   img{
                       margin-left:6px;
                   }
               }
               .nextactive{
                   color:#ccc;
               }
               .center{
                   color:#fff;
                   font-size:14px;
               }
               .center_active{
                   opacity: 0.5!important;
               }
           }
           .two_data{
               justify-content: space-around;
           }
           .pro_item{
               width:100%;
               margin-top:16px;
               position: relative;
               .item_left{
                   width:100%;
                   display: flex;
                   display: -webkit-flex;
                   align-items: center;
                   flex-direction: row;
                   justify-content: space-around;
                   .left{
                        display: inline-block;
                        text-align: center;
                        .num{
                            span:nth-child(1){
                                font-size:36px;
                                color:#fff;
                                display:inline-block;
                                vertical-align: bottom;
                                // font-weight: 700;
                            }
                            span:nth-child(2){
                                font-size:10px;
                                color:#fff;
                                display:inline-block;
                                vertical-align: bottom;
                                margin-left:4px;
                                margin-top:43px;
                            }
                        }
                        .status{
                            font-size:14px;
                            margin-top:16px;
                            color:#fff;
                            opacity: 0.4;
                        }
                   }
                   .center{
                       width:1px;
                       height:40px;
                       background: #ccc;
                       opacity: 0.2;
                   }
               }
           }
           .status_num{
               width:100%;
               height:82px;
               padding:0 8px;
               box-sizing: border-box;
               position: absolute;
               left:0;
               bottom:-41px;
               .status_item{
                   width:100%;
                   height:100%;
                   background-color: #fff;
                   border-radius: 4px;
                //    box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                //    box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.04);
                   box-shadow: 0px 5px 10px 5px rgba(0, 0, 0, 0.04);
                   display: flex;
                   display: -webkit-flex;
                   align-items: center;
                   flex-direction: row;
                   justify-content: space-around;
                   .item_num{
                       text-align: center;
                       .pro_status{
                           font-size:12px;
                           color:#999999;
                       }
                       .pro_actve{
                           color:#4B77B0!important;
                       }
                       .pro_num{
                           margin-top:10px;
                           span:nth-child(1){
                               font-size:14px;
                               color:#999999;
                           }
                           span:nth-child(2){
                               font-size:12px;
                               color:#999999;
                           }
                       }
                   }
                   .line{
                       width:1px;
                       height:20px;
                       background-color: #efefef;
                   }

               }

           }
       }

    }
     .box_nav {
        width: 100%;
        text-align: center;
        font-size: 0;
        padding-top: 20px;
        .box_item:nth-child(1) {
          border-left: 1px solid rgba(255, 255, 255, 0.5);
        }
        .box_item {
          display: inline-block;
          width: 78px;
          height: 30px;
          border-right: 1px solid rgba(255, 255, 255, 0.5);
          border-bottom: 1px solid rgba(255, 255, 255, 0.5);
          border-top: 1px solid rgba(255, 255, 255, 0.5);
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          color: #fff;
          opacity: 0.7;
        }
        .select_active1 {
          background-color: #fff;
          color: #4b77b0;
          opacity: 1;
        }
      }
  .all_list {
    box-sizing: border-box;
    margin-left: 16px;
    margin-right: 16px;
    overflow: hidden;
    margin-top: 250px;
    background-color: #fafafa;
    .all_list_top {
      margin-top: 65px;
      overflow: hidden;
      background-color: #ffffff;
      padding-left: 18px;
      padding-right: 18px;
      margin-bottom: 20px;
      box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
    }
    .all_list_item {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      line-height: 32px;
      span {
        font-size: 14px;
        color: #4a4a4a;
      }
    }
    .all_list_active {
      border-bottom: 1px solid #efefef;
    }
    .all_item {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      border-bottom: 1px solid #efefef;
      padding: 24px 0;
      font-size: 0;
      .tip_one {
        font-size: 13px;
        width: 40%;
        line-height: 16px;
        color: #4a4a4a;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tip_two {
        width: 20%;
        font-size: 14px;
        color: #4a4a4a;
        text-align: left;
      }
      .right {
        width: 40%;
        // display: flex;
        // display: -webkit-flex;
        // align-items: center;
        // flex-direction: row;
        text-align: right;
        .price {
          font-size: 14px;
          color: #4a4a4a;
          display: inline-block;
          // color:red;
        }
        .arrow_right {
          width: 5px;
          height: 8px;
          margin-left: 6px;
          display: inline-block;
        }
      }
    }
    .box1 {
      text-align: center;
      margin-top: 64px;
      height: 268px;
      img {
        display: inline-block;
        width: 72px;
        height: 64px;
      }
      .tip1 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 24px;
      }
      .tip2 {
        font-size: 14px;
        color: #9b9b9b;
        margin-top: 8px;
      }
    }
  }
  .animate_active {
    animation: changehide 1s ease-out forwards;
  }
  .animate_active1 {
    animation: changehide1 1s ease-out backwards;
  }
  @keyframes changehide {
    0% {
      opacity: 1;
      right: 0;
    }
    100% {
      opacity: 0.4;
      right: -35px;
    }
  }
  .go_home {
    position: fixed;
    right: 0;
    top: 538px;
    width: 59px;
    height: 59px;
    background-color: #e4f5ff;
    padding: 9px 10px 9px 9px;
    border-radius: 29px 0 0 29px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
